import { Deal, DealForm, Valuation, ValuationForm } from '../types/deal';
import { http } from './http';
import { DEAL_STAGE, SECURITY } from './codes';

/** 투자 건 · 평가액 — /api/deals · /api/valuations */
type Row = Omit<Deal, 'stage' | 'securityKind'> & { stage: string; securityKind: string | null; [k: string]: unknown };
const toUi = (r: Row): Deal => ({ ...(r as any), stage: DEAL_STAGE.toUi(r.stage)!, securityKind: SECURITY.toUi(r.securityKind), note: r.note ?? '' });
const fromUi = (p: Partial<Deal>) => {
  const { id, createdAt, updatedAt, deletedAt, ...rest } = p as any;
  if ('stage' in p) rest.stage = DEAL_STAGE.toDb(p.stage);
  if ('securityKind' in p) rest.securityKind = SECURITY.toDb(p.securityKind);
  return rest;
};

export const dealApi = {
  async list(): Promise<Deal[]> {
    const rows = (await http.get<Row[]>('/deals')).map(toUi);
    return rows.sort((a, b) => (b.investedOn ?? '').localeCompare(a.investedOn ?? ''));
  },
  async get(id: number): Promise<Deal | undefined> {
    return toUi(await http.get<Row>(`/deals/${id}`));
  },
  valuations(): Promise<Valuation[]> {
    return http.get<Valuation[]>('/valuations');
  },
  /** 건별 최신 평가액. 지표의 「잔여가치」가 이것이다 */
  async latestValues(): Promise<Record<number, Valuation>> {
    const out: Record<number, Valuation> = {};
    (await this.valuations()).sort((a, b) => a.valuedOn.localeCompare(b.valuedOn)).forEach((v) => { out[v.dealId] = v; });
    return out;
  },
  async create(form: DealForm): Promise<Deal> {
    return toUi(await http.post<Row>('/deals', {
      vehicleId: form.vehicleId, companyId: form.companyId,
      // 납입일이 있으면 이미 집행한 것이다
      stage: form.investedOn ? 'invested' : 'review',
      securityKind: SECURITY.toDb(form.securityKind), acquisition: form.acquisition, investedOn: form.investedOn || null, note: form.note.trim(),
      shares: form.shares, pricePerShare: form.pricePerShare,
    }));
  },
  async update(id: number, patch: Partial<Deal>): Promise<Deal> {
    return toUi(await http.patch<Row>(`/deals/${id}`, fromUi(patch)));
  },
  addValuation(dealId: number, form: ValuationForm): Promise<Valuation> {
    return http.post<Valuation>('/valuations', {
      dealId, valuedOn: form.valuedOn, ourValue: form.ourValue ?? 0, companyValue: form.companyValue, source: form.source, note: form.note.trim(),
    });
  },
};
